function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import React from 'react';
import { Box } from '@applyboard/ui-components';
import { PageWrapper } from '@applyboard/ab-common';
import Application from "./Application";
import InitialPropsContext from "../../components/InitialPropsContext";
import SurveyWrapper from "../../components/SurveyWrapper";
import AddRequirementModal from "../../components/AddRequirementModal";
import { PageSettingsProvider } from "./PageSettings";
import MultipleNotesModal from "../../components/Modals/MultipleNotes";
import { useCreateNotes } from "../../data/notes";
import { useParams } from 'react-router-dom';
var StudentApplication = function StudentApplication(_ref) {
  var initialProps = _ref.initialProps,
    match = _ref.match,
    appName = _ref.appName,
    sidebar = _ref.sidebar,
    applicationStepper = _ref.applicationStepper,
    RemoveFileDialog = _ref.RemoveFileDialog,
    DocumentVerificationModal = _ref.DocumentVerificationModal,
    VerificationResults = _ref.VerificationResults,
    onSidebarOpenChange = _ref.onSidebarOpenChange,
    reloadAggregatedData = _ref.reloadAggregatedData,
    aggregatedDataRequirements = _ref.aggregatedDataRequirements,
    RPSelfEvaluation = _ref.RPSelfEvaluation,
    RecommendedProgramsDialogLoader = _ref.RecommendedProgramsDialogLoader,
    HybridRequirementDecisionReasons = _ref.HybridRequirementDecisionReasons,
    HybridRequirementDialogButton = _ref.HybridRequirementDialogButton,
    HybridRequirementPreviewMode = _ref.HybridRequirementPreviewMode,
    isRequirementEvaluationPending = _ref.isRequirementEvaluationPending,
    ApplicantRequirementList = _ref.ApplicantRequirementList,
    AdminRequirementList = _ref.AdminRequirementList,
    renderNotesList = _ref.renderNotesList,
    _ref$hideApplicationR = _ref.hideApplicationRequirementsHeader,
    hideApplicationRequirementsHeader = _ref$hideApplicationR === void 0 ? false : _ref$hideApplicationR,
    _ref$hideAdminRequire = _ref.hideAdminRequirementsHeader,
    hideAdminRequirementsHeader = _ref$hideAdminRequire === void 0 ? false : _ref$hideAdminRequire,
    header = _ref.header,
    canCreateBulkNote = _ref.canCreateBulkNote,
    commissionTab = _ref.commissionTab;
  var applicationId = Number(match && match.params && match.params.application_id);
  var isAdmin = appName === 'admin';
  return /*#__PURE__*/React.createElement(PageSettingsProvider, {
    appName: appName
  }, /*#__PURE__*/React.createElement(PageWrapper, null, /*#__PURE__*/React.createElement(Box, {
    mb: 4
  }, header), /*#__PURE__*/React.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/React.createElement(InitialPropsContext.Provider, {
    value: initialProps
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement(Application, _extends({
    applicationId: applicationId
  }, initialProps, {
    isAdmin: isAdmin,
    sidebar: sidebar,
    applicationStepper: applicationStepper,
    reloadAggregatedData: reloadAggregatedData,
    RemoveFileDialog: RemoveFileDialog,
    DocumentVerificationModal: DocumentVerificationModal,
    VerificationResults: VerificationResults,
    onSidebarOpenChange: onSidebarOpenChange,
    RPSelfEvaluation: RPSelfEvaluation,
    aggregatedDataRequirements: aggregatedDataRequirements,
    RecommendedProgramsDialogLoader: RecommendedProgramsDialogLoader,
    HybridRequirementDialogButton: HybridRequirementDialogButton,
    HybridRequirementPreviewMode: HybridRequirementPreviewMode,
    HybridRequirementDecisionReasons: HybridRequirementDecisionReasons,
    isRequirementEvaluationPending: isRequirementEvaluationPending,
    ApplicantRequirementList: ApplicantRequirementList,
    AdminRequirementList: AdminRequirementList,
    renderNotesList: renderNotesList,
    hideApplicationRequirementsHeader: hideApplicationRequirementsHeader,
    hideAdminRequirementsHeader: hideAdminRequirementsHeader,
    canCreateBulkNote: canCreateBulkNote,
    commissionTab: commissionTab
  })), /*#__PURE__*/React.createElement(LegacyMultipleNotesModal, null), /*#__PURE__*/React.createElement(SurveyWrapper, null), /*#__PURE__*/React.createElement(AddRequirementModal, {
    reloadAggregatedData: reloadAggregatedData
  })))))));
};
export function LegacyMultipleNotesModal(_ref2) {
  var noteType = _ref2.noteType;
  var params = useParams();
  var applicationId = Number(params.application_id);
  var _useCreateNotes = useCreateNotes(applicationId),
    createNotes = _useCreateNotes.createNotes;
  return /*#__PURE__*/React.createElement(MultipleNotesModal, {
    createNotes: createNotes,
    noteType: noteType
  });
}
export default StudentApplication;